<div class="painel pr-4 pl-4">
  <mat-list>
    <mat-list-item>
      <h1 class="text-uppercase font-weight-bold mb-0">Cadastro Vendedor</h1>
    </mat-list-item>

  </mat-list>
</div>

<div class="ativacoes  pr-4 pl-4">

  <form [formGroup]="cadastroVendedor" (submit)="cadastrarVendedor()">

    <mat-form-field class="w-100">
      <mat-label>E-mail</mat-label>
      <input type="email" formControlName="email" matInput>
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>Nome</mat-label>
      <input formControlName="nome" matInput>
    </mat-form-field>


    <mat-form-field class="w-100">
      <mat-label>Senha</mat-label>
      <input formControlName="senha" matInput>
    </mat-form-field>


    <mat-form-field class="w-100">
      <mat-label>Sigla da Marca</mat-label>
      <input type="string" formControlName="sigla_marca" matInput>
    </mat-form-field>



    <div class="form-group">
      <button type="submit" class="btn btn-azul btn-block mb-3">Cadastrar</button>
    </div>

    <div class="alert {{msg.type}}" *ngIf="msg">
      {{msg.message}}
    </div>

  </form>

</div>
